<div
  class="cts-step-tile cts-step-tile--{{
    status === 'null'
      ? 'not-executed'
      : stepStatusService.translate(status, isSuccessful)
  }}"
>
  @if (status !== 'null' && showStatusIcon) {
    <sh-icon
      icon="{{ this.stepStatusService.mapToIcon(status) }}"
      size="s"
    ></sh-icon>
  }
</div>
